export default function() {
  return {
    segments: [],
    segment: {},
    lists: []
  }
}
